module.exports = __webpack_public_path__ + "static/img/4-07.dbde90d.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/4-07.png
// module id = 238
// module chunks = 0